import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'whiteAlpha.100');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.700', 'white');
  const secondaryTextColor = useColorModeValue('gray.500', 'gray.400');
  const inputBackground = useColorModeValue('white', 'whiteAlpha.50');
  const hoverBackground = useColorModeValue('gray.50', 'whiteAlpha.100');
  const menuBackground = useColorModeValue('white', 'navy.800');
  const menuItemHover = useColorModeValue('gray.100', 'navy.700');
  const menuItemChecked = useColorModeValue('blue.50', 'navy.900');

  return {
    backgroundCardColor,
    borderColor,
    textColor,
    secondaryTextColor,
    inputBackground,
    hoverBackground,
    menuBackground,
    menuItemHover,
    menuItemChecked,
  };
};
